<b-button :type="type" class="cta-block__button" rounded @click="open">
	<span>{{ value }}</span>
</b-button>
